const LogoDashboard = (props) => (
  <img
    alt="Logo"
    src="/static/logo.png"
    height="24px"
    width="128px"
    {...props}
  />
);

export default LogoDashboard;
